import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=3ae3f9db&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=3ae3f9db&prod&scoped=true&lang=scss"
import style1 from "./menu.vue?vue&type=style&index=1&id=3ae3f9db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3f9db",
  null
  
)

export default component.exports